import { useCustomization } from "~/Redux/Customization";

export const useIsAiCompletionEnabled = () => {
    const isEnabled = useCustomization(x => x.ClientIsMessageBoardAiCompletionEnabled);
    return !!isEnabled;
};
